import { useState, useMemo } from "react";
import { fixAssetUrl } from "../lib/api";

/**
 * SmartImage – tries a list of image URL candidates in order. If one fails
 * to load (404, broken host, etc.), automatically advances to the next.
 * When all candidates fail, renders the provided <fallback/> node.
 *
 * Props:
 *   candidates: string[]  Ordered list of image URLs to try.
 *   alt: string           Alt text.
 *   className: string     Applied to the <img>.
 *   wrapperClassName       Applied to the wrapper div.
 *   fallback: ReactNode    Rendered when every candidate fails.
 *   testId: string         data-testid for the wrapper.
 */
export default function SmartImage({ candidates, alt = "", className = "", wrapperClassName = "", fallback = null, testId, loading = "lazy" }) {
  const list = useMemo(() => (candidates || []).filter(Boolean).map(fixAssetUrl), [candidates]);
  const [idx, setIdx] = useState(0);
  const allFailed = list.length === 0 || idx >= list.length;

  return (
    <div className={wrapperClassName} data-testid={testId}>
      {!allFailed && (
        <img
          key={list[idx]}
          src={list[idx]}
          alt={alt}
          className={className}
          loading={loading}
          onError={() => setIdx((i) => i + 1)}
        />
      )}
      {allFailed && fallback}
    </div>
  );
}
